<form class="flex flex-col space-y-2" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <ng-container *transloco="let t; read: 'contactForm.field'">
    <mat-form-field class="mb-1" subscriptSizing="dynamic">
      <mat-label>{{ t('message.label') }}</mat-label>
      <textarea [placeholder]="t('message.placeholder')" matInput rows="4" formControlName="message"></textarea>
    </mat-form-field>

    <p class="mb-3">{{ t('contact-method.label') }}</p>
    <mat-radio-group class="mb-4" [attr.aria-label]="t('contact-method.label')" formControlName="contactType" color="primary">
      <mat-radio-button value="phone">{{ t('contact-method.phone') }}</mat-radio-button>
      <mat-radio-button class="ml-8" value="email">{{ t('contact-method.email') }}</mat-radio-button>
    </mat-radio-group>

    @if (contactForm.controls.contactType.value === 'phone') {
      <mat-form-field>
        <mat-label>{{ t('phone.label') }}</mat-label>
        <input [placeholder]="t('phone.placeholder')" type="tel" matInput formControlName="senderPhone" autocomplete="tel" />
        <mat-error />
      </mat-form-field>
    }

    @if (contactForm.controls.contactType.value === 'email') {
      <mat-form-field>
        <mat-label>{{ t('email.label') }}</mat-label>
        <input [placeholder]="t('email.placeholder')" type="email" matInput formControlName="senderEmail" autocomplete="email" />
        <mat-error />
      </mat-form-field>
    }

    <mat-form-field>
      <mat-label>{{ t('full-name.label') }}</mat-label>
      <input [placeholder]="t('full-name.placeholder')" type="text" matInput formControlName="senderName" required autocomplete="name" />
      <mat-error />
    </mat-form-field>

    @if (recaptcha.ready | async) {
      <div class="pb-5">
        <re-captcha formControlName="recaptcha" />
      </div>
    }
  </ng-container>

  <ng-container *transloco="let t; read: 'contactForm.actions'">
    <div class="flex">
      <button
        class="gtm-contact-form-send"
        #sendButton
        [disabled]="!contactForm.valid"
        [rmaLoadingIndicator]="submittingStatus === 'Submitting'"
        mat-flat-button
        type="submit"
        color="primary"
        data-id="contact-form-submit">
        <rma-icon glyph="mail" />
        <span class="ml-1">{{ t('send') }}</span>
      </button>
    </div>

    @if (submittingStatus) {
      <div class="mt-6 flex">
        @if (submittingStatus === 'Success') {
          <rma-callout [message]="'form.label.sent' | transloco" calloutType="success" />
          <rma-trixel
            [trixelImgUrl]="contact.profileConnectionTrixelUrl || ''"
            trixelSourceCategory="RateMyAgent-FindMyAgent-ContactForm" />
        }
        @if (submittingStatus === 'Error') {
          <rma-callout [message]="'form.label.sendFailure' | transloco" />
        }
      </div>
    }

    <p class="pt-4" [innerHtml]="t('tandc')"></p>
  </ng-container>
</form>
